import { jsx } from "react/jsx-runtime";
import { useCollaborationStatus } from "../../hooks/useIsMultiplayer.mjs";
import { OfflineIndicator } from "../OfflineIndicator/OfflineIndicator.mjs";
import { CenteredTopPanelContainer } from "./CenteredTopPanelContainer.mjs";
function DefaultTopPanel() {
  const isOffline = useCollaborationStatus() === "offline";
  return /* @__PURE__ */ jsx(CenteredTopPanelContainer, { children: isOffline && /* @__PURE__ */ jsx(OfflineIndicator, {}) });
}
export {
  DefaultTopPanel
};
//# sourceMappingURL=DefaultTopPanel.mjs.map
